module.exports = (user, can) => {
    if (typeof user.roles !== 'undefined') {
        let permissions = user.roles.permissions.map(p => p.slug) 
        return permissions.indexOf(can) > -1 ? true : false
    }
}